import { getCurrentInstance } from 'vue'
import { Vue3LoggerPlugin } from '@gf/gf-logger'
import vueDebounce from "vue-debounce/src/index.js"
import BeneficiarySearchPlugin from '../plugins/BeneficiarySearchPlugin'
import EventServicePlugin from '../plugins/EventServicePlugin'
import store from '../store'

export default {
  install(options) {
    getCurrentInstance().appContext.app.use(Vue3LoggerPlugin)
    getCurrentInstance().appContext.app.use(BeneficiarySearchPlugin, {
      apiDomain: options?.apiDomain || ''
    })
    getCurrentInstance().appContext.app.use(EventServicePlugin, {
      apiDomain: options?.apiDomain || '',
      region: options?.region || '',
    })
    getCurrentInstance().appContext.app.use(vueDebounce)
    getCurrentInstance().appContext.app.use(store)
  }
}